import { useMemo } from "react";
import { useHistory, useParams } from "react-router";
import ActivityLogCardIcon from "components/svg-icons/activity-log-card-icon";
import ReportCard from "../components/report-card";

function AuditReportsTab() {
  const history = useHistory();
  const { projectId } = useParams() as { projectId?: string };

  const cardDetails = useMemo(
    () => ({
      activityLog: (
        <div>
          <div>
            Track file-related user activities: view uploads, downloads and
            deletions of files by user and date.
          </div>
          <div className="mt-2">
            <ul className="list-disc mx-4 p-0">
              <li>CSV Export</li>
              <li>Print</li>
            </ul>
          </div>
        </div>
      )
    }),
    []
  );

  return (
    <div
      className="w-full max-w-screen-2xl mx-auto grow grid grid-cols-2 py-4 px-6"
      data-testid="audit-reports-page-body"
    >
      <div
        className="flex flex-wrap gap-x-6 col-span-2"
        data-testid="audit-reports-card-grid"
      >
        <ReportCard
          title="Activity Log"
          icon={<ActivityLogCardIcon size={48} />}
          onClick={() => {
            history.push(
              projectId
                ? `/project/${projectId}/reports/audit-reports/activity-log`
                : "/reports/audit-reports/activity-log"
            );
          }}
          detail={cardDetails.activityLog}
          containerTestId="report-card-activity-log"
          viewButtonTestId="report-card-activity-log-view"
        />
      </div>
    </div>
  );
}

export default AuditReportsTab;
